import { render, staticRenderFns } from "./pos-Purchase.vue?vue&type=template&id=58c7719f"
import script from "./pos-Purchase.vue?vue&type=script&lang=js"
export * from "./pos-Purchase.vue?vue&type=script&lang=js"
import style0 from "./pos-Purchase.vue?vue&type=style&index=0&id=58c7719f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports